import React, { useState } from 'react';
import InputTextNested from '../../../Components/Form/InputTextNested';
import BreadCrumbs from '../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { FormContainer } from '../../../AdminRoutes/CreateRoutes/CreateForm.styles';
import { useParams } from 'react-router-dom';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';
import AuthCheckManager from '../../../Utils/AuthCheck/ManagerCheck.auth';
import SubcontractorSubmit from './SubcontractorSubmit.component';
import { FormBackground } from '../../../AdminRoutes/CreateRoutes/CreateForm.styles';

const CreateSubcontractor = () => {
  const { id: companyId } = useParams();
  const [subcontractor, setSubcontractor] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    pin: '',
    companyId: companyId,
    permissions: [],
    role: 'Subcontractor',
    type: 'Subcontractor',
    active: true,
    companyName: '',
  });

  return (
    <>
      <AuthCheckManager>
        <HelmetHelper
          title="Create Subcontractor"
          description="Form for creating a subcontractor"
        />
        <FormContainer>
          <BreadCrumbs
            one="Company Dashboard"
            oneLink="/company"
            two="Create Subcontractor"
          />
          <h2>CREATE SUBCONTRACTOR</h2>
          <FormBackground>
            <form>
              <InputTextNested
                title="First Name"
                requiredInput={true}
                value={subcontractor.firstName}
                nestedValue={setSubcontractor}
                upperValue={subcontractor}
                name="firstName"
              />
              <InputTextNested
                title="Last Name"
                requiredInput={true}
                value={subcontractor.lastName}
                nestedValue={setSubcontractor}
                upperValue={subcontractor}
                name="lastName"
              />

              <InputTextNested
                title="Email"
                requiredInput={true}
                value={subcontractor.email}
                nestedValue={setSubcontractor}
                upperValue={subcontractor}
                name="email"
              />
              <InputTextNested
                title="Phone"
                value={subcontractor.phone}
                nestedValue={setSubcontractor}
                upperValue={subcontractor}
                name="phone"
              />
              <InputTextNested
                title="Pin"
                requiredInput={true}
                value={subcontractor.pin}
                nestedValue={setSubcontractor}
                upperValue={subcontractor}
                name="pin"
              />
              <InputTextNested
                title="Company Name"
                value={subcontractor.companyName}
                nestedValue={setSubcontractor}
                upperValue={subcontractor}
                name="companyName"
              />
              <p>Permissions coming soon...</p>
            </form>
          </FormBackground>
          <SubcontractorSubmit
            subcontractor={subcontractor}
            companyId={companyId}
          />
        </FormContainer>
      </AuthCheckManager>
    </>
  );
};

export default CreateSubcontractor;
